import {
	mapActions,
	mapState
} from 'vuex';

import {
	Emoji,
	Picker
} from 'emoji-mart-vue';

// import $ from 'jquery';

import {
	Popover
} from 'element-ui';

import toastr from '@/support/toastr';

import New from '@/domains/inbox/message-reply/new/new';
import MessageUsers from '@/domains/inbox/message-users/main';

import i18nEmoji from '@/i18n/i18n-emoji.json';

export default {
	name: 'message-reply',
	components: {
		Emoji,
		Picker,
		New,
		MessageUsers,
		Popover
	},
	data: () => ({
		message: '',
		emojiPickerVisible: false,
		i18n: i18nEmoji['pt_BR']
	}),
	computed: {
		...mapState({
			messageGroup: (state) => state.Inbox.messageGroup,
			messages: (state) => state.Inbox.messageGroup.messages,
			messageGroupUsers: (state) => state.Inbox.messageGroup.users,
			loggedUserId: (state) => state.Logged.user.id
		})
	},
	methods: {
		...mapActions([
			'getMessageGroup',
			'sendMessageChat'
		]),
		insertAtCaret(text, element = 'textarea') {

			// https://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery#answer-28353499

			let textarea = document.querySelector(element);
			let caretPosition = textarea.selectionStart;
			let front = (textarea.value).substring(0, caretPosition);
			let back = (textarea.value).substring(textarea.selectionEnd, textarea.value.length);

			this.message = front + text + back;

		},
		addEmoji(emoji) {
			this.insertAtCaret(emoji.native);
		},
		send() {

			this.sendMessageChat({
				from: {
					userId: this.loggedUserId
				},
				message: this.message
			}).then(() => {

				this.getMessageGroup(this.$router.history.current.params.id).then(() => {
					this.scrollToBottom();
				});

				toastr.success('Mensagem enviada com sucesso!');
				this.message = '';

			});

		},
		scrollToBottom() {

			/*$('html, body').animate({
				scrollTop: $(document).height()
			}, 1000);*/

		}
	},
	created() {

		this.getMessageGroup(this.$router.history.current.params.id);

	}
};



// WEBPACK FOOTER //
// ./sources/domains/inbox/message-reply/index.js